export default __webpack_public_path__ + "static/media/arial.6a244608.ttf";